import { render, staticRenderFns } from "./ScholarshipApplicationList.vue?vue&type=template&id=557a16f9"
import script from "./ScholarshipApplicationList.vue?vue&type=script&lang=js"
export * from "./ScholarshipApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports